import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-phonefield', 'INVALID', 'Sisestud telefoninumber on vigane.');
Labels.set('ui-phonefield', 'CHOOSE_COUNTRY', 'Valige riik.');
Labels.set('ui-phonefield', 'PHONENR', 'Telefoninumber');
Labels.set('ui-phonefield', 'NUMBER', 'number');
